import { Alert } from "react-bootstrap";
import styles from "./index.module.scss";

interface ErrorPageProps {
  title?: string;
  message?: string;
}

export default function ErrorPage({
  title = "Something went wrong!",
  message = "Please reload the page and try again. If the problem persists, please contact the dev team.",
}: ErrorPageProps) {
  return (
    <div className={styles.errorPage}>
      <Alert variant="warning">
        <Alert.Heading>{title}</Alert.Heading>
        <p>{message}</p>
      </Alert>
    </div>
  );
}
